(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-title"]) return;
  try {
    
document.getElementById('shopify-section-header').classList.add('white')

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-featured-title"]) return;
  try {
    
  document.getElementById('shopify-section-header').classList.add('white')

  } catch(e) { console.error(e); }
})();
})();
